import type { GradeDto } from '../services/gradeApi';

/** Matches backend The_Platform.Entity.DTOs.GradeEnum */
export const GRADE_ENUM_BY_LEVEL: Record<number, string> = {
  1: 'Primary1',
  2: 'Primary2',
  3: 'Primary3',
  4: 'Primary4',
  5: 'Primary5',
  6: 'Primary6',
  7: 'Prep1',
  8: 'Prep2',
  9: 'Prep3',
  10: 'Secondary1',
  11: 'Secondary2',
  12: 'Secondary3',
};

const VALID_GRADE_ENUMS = new Set(Object.values(GRADE_ENUM_BY_LEVEL));

/**
 * RegisterDto.AcademicYear must be a GradeEnum name (e.g. Secondary1), not API code (e.g. GRADE-10).
 */
export function resolveAcademicYearForRegistration(grade: GradeDto): string | null {
  const code = grade.code.trim();
  if (VALID_GRADE_ENUMS.has(code)) {
    return code;
  }

  const fromCodeLevel = /^GRADE-(\d+)$/i.exec(code);
  if (fromCodeLevel) {
    const level = Number(fromCodeLevel[1]);
    return GRADE_ENUM_BY_LEVEL[level] ?? null;
  }

  return GRADE_ENUM_BY_LEVEL[grade.level] ?? null;
}
